<template>

  <v-client-table
    id="paymentsTable"
    ref="paymentsTable"
    name="paymentsTable"
    :data="license.payments"
    :columns="columns"
    :options="tableOptions"
    @row-click="click => selectPayment(click.row)"
    >

    <span slot="obs" slot-scope="props">
      {{props.row.obs ? props.row.obs : '---'}}
    </span>

    <span slot="updated_at" slot-scope="{row}">
      {{row.updated_at | localTime('YYYY-MM-DD HH:mm')}}
    </span>

  </v-client-table>

</template>

<script>
import Vue from 'vue'
import { ClientTable, Event } from 'vue-tables-2'
Vue.use(ClientTable, {}, false, 'bootstrap4')

export default {
  props: {
    license: {
      type: Object,
      required: true
    }
  },
  components: {
    Event
  },
  data: function () {
    return {
      columns: ['updated_at', 'date', 'amount', 'document_reference', 'obs'],
      tableOptions: {
        texts: {
          count: this.$t('tables.records') + ' {from} ' + this.$t('tables.to') + ' {to} ' + this.$t('tables.of') + ' {count}|{count} ' + this.$t('tables.records_') + '|' + this.$t('tables.one_record'),
          first: this.$t('tables.first'),
          last: this.$t('tables.last'),
          filter: this.$t('tables.filter') + ':',
          filterPlaceholder: this.$t('tables.search_text'),
          limit: this.$t('tables.records') + ':',
          page: this.$t('tables.page') + ':',
          noResults: this.$t('tables.no_records'),
          filterBy: this.$t('tables.filter_by') + ' {column}',
          loading: this.$t('tables.loading') + '...',
          defaultOption: this.$t('tables.select') + ' {column}',
          columns: this.$t('tables.columns')
        },
        sortable: ['updated_at', 'date', 'amount'],
        headings: {
          name: this.$t('users.inputs.name'),
          updated_at: this.$t('licenses.payments.updated_at'),
          date: this.$t('licenses.payments.date'),
          amount: this.$t('licenses.payments.amount'),
          document_reference: this.$t('licenses.payments.document_reference'),
          obs: this.$t('licenses.payments.obs')
        },
        columnsClasses: {
          obs: 'obs'
        },
        skin: 'table table-striped table-hover is-fullwidth',
        sortIcon: {
          is: 'fa-sort',
          base: 'fa fa-fw',
          up: 'fa-sort-up',
          down: 'fa-sort-down'
        },
        columnsDropdown: false,
        pagination: {
          chunk: 4,
          nav: 'scroll'
        }
      }
    }
  },
  methods: {
    selectPayment: function (payment) {
      this.$emit('paymentSelected', payment)
    },
    setFilter: function (search) {
      this.$refs.paymentsTable.setFilter(search)
    }
  }
}
</script>

<style lang="scss">
  #paymentsTable th.obs {
    min-width: 200px;
  }
</style>
